/**
 * The current window for a frontend period ('7d', 'mtd', 'YYYY-MM-DD:YYYY-MM-DD'),
 * resolved exactly as the page's own fetch and `usePreviousPeriodMetrics` resolve it.
 */
import { parseGranularityPeriod } from '@/lib/api/external-api'
import { transformToLegacy } from '@/lib/api/bridge/transformers'
import type { PeriodWindow } from '@/lib/utils/previousPeriod'

export function resolvePeriodWindow(period: string): PeriodWindow | null {
  try {
    const { start, end } = parseGranularityPeriod(transformToLegacy.period(period))
    return { start, end }
  } catch {
    return null
  }
}
